var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoNight = function SvgHospitalinfoNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "m22.5 7 1.2 2.03 2.3.51-1.56 1.77.22 2.35-2.16-.94-2.16.94.22-2.35L19 9.54l2.3-.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M11 10c0-1.48.3-2.89.83-4.17A10.98 10.98 0 0 0 5 16c0 6.08 4.92 11 11 11 4.6 0 8.53-2.82 10.17-6.83-1.28.53-2.69.83-4.17.83-6.07 0-11-4.93-11-11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M11 10c0-1.48.3-2.89.83-4.17C9.76 8.27 8.26 11.46 9 16c.56 3.4 3.46 6.35 7 7 4.49.83 7.51-.15 10.17-2.83-1.28.53-2.69.83-4.17.83-6.07 0-11-4.93-11-11"
  })));
};
export default SvgHospitalinfoNight;